@let readableNumber = readableNumberSg();
@let isOverflowing = isOverflowingSg();
@let overflowPlaceholder = overflowPlaceholderSg();

<div
  #hidden
  class="atn-ds-table-cell-value-number__hidden"
>
  {{ readableNumber }}
</div>
<div #number>
  {{ isOverflowing ? overflowPlaceholder : readableNumber }}
</div>
